import RichTextLimited from './RichTextLimited';

export default RichTextLimited;
